import { useLanguage } from '@nzyme/vue-i18n/useLanguage.js';
import { formatDate } from '@sigma/common/i18n/formatDate.js';
/**
 * Binds `formatDate` to the viewer's current reactive language, so call sites don't each have to
 * resolve `useLanguage()` and thread `lang.value` through by hand. The language is read inside the
 * returned function (not captured once at setup), so a language switch changes the locale used by
 * the very next call.
 */
export function useDateFormat() {
    const lang = useLanguage();
    return (date, format) => formatDate(date, format, lang.value);
}
//# sourceMappingURL=useDateFormat.js.map